import PrepaidCardApi from '@apis/prepaid/PrepaidCardApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const prepaidCardImageQueries = createQueryKeys('prepaidCardImages', {
    list: () => ({
        queryKey: ['prepaidCardImages'],
        queryFn: () => PrepaidCardApi.getPrepaidCardImages(),
    }),
    detail: (id: string) => ({
        queryKey: ['prepaidCardImage', id],
        queryFn: () => PrepaidCardApi.getPrepaidCardImage(id),
    }),
});

export default prepaidCardImageQueries;
